import type { PlayerData } from '../../components/PlayersStats/PlayersStats.types';

const sortGoalPlayersData = (player1: PlayerData, player2: PlayerData) =>
  (player2.goals || 0) - (player1.goals || 0);

export default sortGoalPlayersData;
